import { createSelector } from 'reselect';
import get from 'lodash/get';
import { isNumeric, isUuid, isEmpty } from '../../js/app/react/validators';
import { allPlans } from '../../js/app/react/financialPlans';

const planSelectionSelector = state => state.PlanSelectionNewWhatIfs;

export const financialPlanCapsuleWrapperSelector = state => state.FinancialPlanCapsuleWrapper;

export const planSelection = state => planSelectionSelector(state);
export const clientId = (state, props) =>
  props.clientId || state.FinancialPlanCapsuleWrapper.currentClientId;
export const capsuleId = (_, props) => props.capsuleId;

export const isInitialized = createSelector(
  financialPlanCapsuleWrapperSelector,
  clientId,
  capsuleId,
  (financialPlanCapsuleWrapper, clientID, capsuleID) =>
    isNumeric(clientID) &&
    (!capsuleID || !isEmpty(get(financialPlanCapsuleWrapper, `${clientID}.${capsuleID}`, null))),
);

export const fpId = createSelector(
  isInitialized,
  financialPlanCapsuleWrapperSelector,
  clientId,
  capsuleId,
  (isInitializedArg, financialPlanCapsuleWrapper, clientID, capsuleID) => {
    if (!isInitializedArg) {
      return null;
    }
    return get(financialPlanCapsuleWrapper, `${clientID}.${capsuleID}.fpId`, null);
  },
);

export const isCurrentSelector = createSelector(
  state => state,
  (_, { clientId: currentClientId }) => currentClientId,
  fpId,
  isInitialized,
  (state, clientIdArg, overviewCapsuleFpId, isInitializedArg) => {
    if (!isInitializedArg) {
      return false;
    }
    return (allPlans(state, clientIdArg) || []).reduce(
      (result, { planId, isCurrent }) => (planId === overviewCapsuleFpId ? isCurrent : result),
      false,
    );
  },
);

export const name = createSelector(
  isInitialized,
  financialPlanCapsuleWrapperSelector,
  clientId,
  capsuleId,
  (isInitializedArg, financialPlanCapsuleWrapper, clientID, capsuleID) => {
    if (!isInitializedArg) {
      return null;
    }
    return get(financialPlanCapsuleWrapper, `${clientID}.${capsuleID}.proposed_plan`, null);
  },
);

export const plans = (state, props) => {
  if (!isInitialized(state, props)) {
    return [];
  }
  const clientPlanSelection = planSelection(state, props)[clientId(state, props)];
  const fpID = fpId(state, props);
  let all = clientPlanSelection.plans || [];
  if (clientPlanSelection.selectedPlan) {
    all = all.concat(clientPlanSelection.selectedPlan);
  }
  return all.filter(plan => plan.planId !== fpID);
};

export const getSelectedPlan = (state, props) => {
  if (!isInitialized(state, props)) {
    return '';
  }
  const clientPlanSelection = planSelection(state, props)[clientId(state, props)];
  const fpID = fpId(state, props);
  let all = clientPlanSelection.plans || [];
  if (clientPlanSelection.selectedPlan) {
    all = all.concat(clientPlanSelection.selectedPlan);
  }
  return all.find(plan => plan.planId === fpID) || {};
};
export const hasFpId = (state, props) => {
  if (!isInitialized(state, props)) {
    return null;
  }
  return isUuid(fpId(state, props));
};
